import Halyard from 'halyard.js/dist/halyard';
import getFBData from './fb.js';

const timezoneOffset = function() {
  function z(n){return (n<10? '0' : '') + n}
  var offset = new Date().getTimezoneOffset();
  var sign = offset < 0? '+' : '-';
  offset = Math.abs(offset);
  return "GMT" + sign + z(offset/60 | 0) + ":" + z(offset%60);
}();

export default new Promise(resolve => {
  const halyard = new Halyard();
  //halyard.setDefaultSetStatements({MonthNames: 'Jan;Feb;Mar;Apr;May;Jun;Jul;Aug;Sep;Oct;Nov;Dec', DayNames: 'Mon;Tue;Wed;Thu;Fri;Sat;Sun'});
  getFBData.then(response => {
    $("#loading-message").html("Creating session app");
    setTimeout(() => {
      const table = new Halyard.Table(response, {fields: [{expr: `ConvertToLocalTime(created_time,'${timezoneOffset}')`, name: 'created', calendarTemplate: true}, {expr: `WeekDay(ConvertToLocalTime(created_time,'${timezoneOffset}'))`, name: 'Day'}, {expr: `Hour(ConvertToLocalTime(created_time,'${timezoneOffset}'))`, name: 'Hour'}]});
      halyard.addTable(table);
      window.halyard = halyard;
      resolve(halyard);
    }, 1000);
  });
});


// WEBPACK FOOTER //
// ./qscript.js